import config from '../config'
import http from '../http'

export default {
    savePattern: async function (payload, userId) {
        const res = await http({
            url: config.PATTERN_SAVEPATTERN,
            method: 'post',
            data: payload,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        return res.data
    },
    editPattern: async function (payload, userId) {
        const res = await http({
            url: config.PATTERN_EDITPATTERN,
            method: 'post',
            data: payload,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        return res.data
    },
    getPatternPage: async function (pageNum,pageSize,galleryType) {
        const res = await http({
            url: config.PATTERN_PATTERNPAGE+'?pageNum='+pageNum+'&pageSize='+pageSize+'&galleryType='+galleryType+'&userId='+JSON.parse(localStorage.getItem('userInfo')).userId,
            method: 'post',
            // data: payload,
        })
        return res.data
    },
    getPatterneDtail: async function (id) {
        const res = await http({
            url: config.PATTERN_GETPATTERNEDTAIL + '?patternInfoId=' + id,
            method: 'post',
        })
        return res.data
    },
    getPatternBadPage: async function (payload) {
        const res = await http({
            // url: config.PATTERN_PATTERNBADPAGE+'?pageNum='+pageNum+'&pageSize='+pageSize+'&pageSize='+pageSize,
            url: config.PATTERN_PATTERNBADPAGE,
            method: 'post', 
            data: payload,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        return res.data
    },
    bindPatter: async function (payload) {
        const res = await http({
            url: config.PATTERN_BINDPATTER,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    updateCustomizedTxt: async function (payload) {
        const res = await http({
            url: config.PATTERN_UPDATECUSTOMIZEDTXT,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    updateCustomizedTxt: async function (payload) {
        const res = await http({
            url: config.PATTERN_UPDATECUSTOMIZEDTXT,
            method: 'post',
            data: payload,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        return res.data
    },
    deletePattern: async function (payload) {
        const res = await http({
            url: config.PATTERN_DELETEPATTERN,
            method: 'post',
            data: payload,
            headers: {
                'Content-Type': 'multipart/form-data',
                'biaoshi':'111'
            }
        })
        return res.data
    },
    startReadyOrders: async function (payload) {
        const res = await http({
            url: config.PATTERN_STARTREADYORDERS,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    selectAllTemuShop: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_SELECTALLTEMUSHOP,
            method: 'post',
            data: payload,
            headers: {
                'Content-Type': 'multipart/form-data',
                'biaoshi':'111'
            }
        })
        return res.data
    },
    getCats: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_GETCATS,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    getAttrs: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_GETATTRS,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    getLogisticsTemplate: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_GETLOGISTICSTEMPLATE,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    getParentSpec: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_GETPARENTSPEC,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    createSpec: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_CREATESPEC,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    getSizecharts: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_GETSIZECHARTS,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    createSizechartsTemplate: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_CREATESIZECHARTSTEMPLATE,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    getSizechartsClass: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_GETSIZECHARTSCLASS,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    getSizechartsSettings: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_GETSIZECHARTSSETTINGS,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    getSizeChartsMeta: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_GETSIZECHARTSMETA,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    createSizecharts: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_CREATESIZECHARTS,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    getWarehouseList: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_GETWAREHOUSELIST,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    uploadGoodsImage: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_UPLOADGOODSIMAGE,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    addGoods: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_ADDGOODS,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    batchAddGoods: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_BATCHADDGOODS,
            method: 'post',
            data: payload,
			timeout: 3000000,
        })
        return res.data
    },
    addStandardPatternPrintGroups: async function (payload, userId) {
        const res = await http({
            url: config.PATTERN_ADDSTANDARDPATTERNPRINTGROUPS,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    addStandardPattern: async function (payload, userId) {
        const res = await http({
            url: config.PATTERN_ADDSTANDARDPATTERN,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    standardPatternPage: async function (payload, userId) {
        const res = await http({
            url: config.PATTERN_STANDARDPATTERNPAGE,
            method: 'post',
            data: payload,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        return res.data
    },
    publishPlatformHeat: async function (payload, userId) {
        const res = await http({
            url: config.PATTERN_PUBLISHPLATFORMHEAT,
            method: 'post',
            data: payload,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        return res.data
    },
    getStandardPatternPrintGroupsList: async function (userId) {
        const res = await http({
            url: config.PATTERN_GETSTANDARDPATTERNPRINTGROUPSLIST +'?userId='+userId,
            method: 'post',
        })
        return res.data
    },
    getStandardPatternDetail: async function (userId,standardPatternId) {
        const res = await http({
            url: config.PATTERN_GETSTANDARDPATTERNDETAIL +'?userId='+userId+'&&standardPatternId='+standardPatternId,
            method: 'post',
        })
        return res.data
    },
    editStandardPattern: async function (payload, userId) {
        const res = await http({
            url: config.PATTERN_EDITSTANDARDPATTERN,
            method: 'post',
            data: payload,
        })
        return res.data
    },
    orderBindPrintImage: async function (payload) {
        const res = await http({
            url: config.PATTERN_ORDERBINDPRINTIMAGE,
            method: 'post',
            data: payload,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        return res.data
    },
    updateOrderItemImage: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_UPDATEORDERITEMIMAGE,
            method: 'post',
            data: payload,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        return res.data
    },
    uploadPintImage: async function (payload) {
        const res = await http({
            url: config.SHOPORDER_UPLOADPINTIMAGE,
            method: 'post',
            data: payload,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        return res.data
    },
    deleteStandardPatternPrintGroups: async function (standardPatternPrintGroupsId) {
        const res = await http({
            url: config.PATTERN_DELETESTANDARDPATTERNPRINTGROUPS +'?standardPatternPrintGroupsId='+standardPatternPrintGroupsId,
            method: 'post',
        })
        return res.data
    },
    deleteStandardPattern: async function (payload, userId) {
        const res = await http({
            url: config.PATTERN_DELETESTANDARDPATTERN,
            method: 'post',
            data: payload,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        return res.data
    },
    addStoreItemNotProductUpdateParents: async function (payload,status) {
        const res = await http({
            url: config.ADDSTOREITEMNOTPRODUCTUPDATEPARENTS+'?isUpdateParents='+status,
            method: 'post',
            data: payload
        })
        return res.data
    },
    getProgress: async function (userId,pageNum,pageSize) {
        const res = await http({
            url: config.SHOPORDER_GETPROGRESS +'?userId='+userId+'&pageNum='+pageNum+'&pageSize='+pageSize,
            method: 'post',
        })
        return res.data
    },
    stopOrDeleteTask: async function (userId,type,taskId) {
        const res = await http({
            url: config.SHOPORDER_STOPORDELETETASK +'?userId='+userId+'&type='+type+'&taskId='+taskId,
            method: 'post',
        })
        return res.data
    },
}